import { ErrorIcon } from '@native-instruments/webex-ni';
import { Link, useParams } from 'react-router';
import { ROUTE_SEGMENTS } from '~/helpers/app-routes';
import { useIntl } from '~/helpers/intl';

export function GeneralErrorPage() {
  const { t } = useIntl();
  const { language } = useParams();

  return (
    <div
      data-testid="general-error-page"
      className="container flex flex-col items-center text-center py-6 xl:py-12 min-h-[600px]"
    >
      <ErrorIcon className="w-6 h-6 text-grey-90" />

      <h1 className="text-2xl font-medium mt-2" data-testid="error-page-title">
        {t('errors.subscription.oops', {
          fallback: 'Oops! Something went wrong!',
        })}
      </h1>

      <p className="mt-2" data-testid="error-page-desc">
        {t('errors.subscription.ErrorProcessing', {
          fallback:
            'We encountered an error processing your request. Please continue with one of the following options:',
        })}
      </p>

      <div className="flex gap-3 mt-4">
        <a
          className="webex-btn webex-btn--regular webex-btn--primary"
          data-testid="error-page-home-link"
          href="/"
        >
          {t('global.homepage ', {
            fallback: 'Homepage',
          })}
        </a>

        <Link
          className="webex-btn webex-btn--regular webex-btn--primary"
          to={`/${language}/${ROUTE_SEGMENTS.catalog}`}
          data-testid="error-page-catalog-link"
        >
          {t('components.header.links.products', {
            fallback: 'Products',
          })}
        </Link>
      </div>
    </div>
  );
}

export function EnglishGeneralErrorPage() {
  return (
    <div
      data-testid="general-error-page"
      className="container flex flex-col items-center text-center py-6 xl:py-12 min-h-[600px]"
    >
      <ErrorIcon className="w-6 h-6 text-grey-90" />

      <h1 className="text-2xl font-medium mt-2" data-testid="error-page-title">
        Oops! Something went wrong!
      </h1>

      <p className="mt-2" data-testid="error-page-desc">
        We encountered an error processing your request. Please continue with
        one of the following options:
      </p>

      <div className="flex gap-3 mt-4">
        <a
          className="webex-btn webex-btn--regular webex-btn--primary"
          data-testid="error-page-home-link"
          href="/"
        >
          Homepage
        </a>

        <Link
          className="webex-btn webex-btn--regular webex-btn--primary"
          to={'/en/catalog-v2/'}
          data-testid="error-page-catalog-link"
        >
          Products
        </Link>
      </div>
    </div>
  );
}
